export default class Validation {
  error: boolean = false;
  text: string = '';
}
